var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ObjectiveBlock"},[_c('b',{staticClass:"primary--text"},[_vm._v("Objectif : ")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.block.config.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }